import { LogIn } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { customOAuthProviders } from '../lib/auth';

export function LoginPage() {
  return (
    <section className="page">
      <PageHeader title="Login / signup" description="Firebase Authentication provider abstraction. Kakao and Naver require custom OAuth token exchange." />
      <div className="grid cols-2">
        {['Google', 'Apple', 'Kakao', 'Naver'].map((provider) => (
          <button className="button secondary" key={provider} type="button">
            <LogIn size={16} aria-hidden="true" />
            Continue with {provider}
          </button>
        ))}
      </div>
      <p className="muted">Manual setup required: {customOAuthProviders.join(', ')}.</p>
    </section>
  );
}
